/*global TTFileTransporter, isImage, TTObjectSubtypeEnum, TTDocumentUseEnum, hError, BuildImageURLForFileGUID */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import validator            from 'validator';

import { Page } from 'moovila-common';
import Masthead from '../Masthead';

let transporterInstance;

const baseImg     = '/assets/images/DownloadAttachment.png';
const fileIconImg = '/assets/images/moovila_internal_console.png';

class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      objectTypeCode: 0,
      objectKeyGUID: '',
      objectSubtypeCode: 0,
      objectSubkeyID: 0,
      documentUseCode: 10,

      memoryImg: baseImg,
      savedImg: baseImg,
      fileGUID: '',
      serverURL: '',
    };
    this.onChange       = this.onChange.bind(this);
    this.onFileChange   = this.onFileChange.bind(this);
    this.renderImages   = this.renderImages.bind(this);
    this.upload         = this.upload.bind(this);
    this.validate       = this.validate.bind(this);
    this.save           = this.save.bind(this);
    this.saveCallback   = this.saveCallback.bind(this);
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value || '';
    this.setState({[name]: value});
  }

  onFileChange(e) {
    if (e.currentTarget.value.length === 0) {
      return;
    }
    
    this.setState({
      memoryImg: baseImg,
      savedImg: baseImg,
      fileGUID: '',
      serverURL: '',
    });

    transporterInstance = new TTFileTransporter({
      objectTypeCode: this.state.objectTypeCode,
      objectKeyGUID: this.state.objectKeyGUID,
      objectSubtypeCode: this.state.objectSubtypeCode,
      objectSubkeyID: this.state.objectSubkeyID,
      documentUseCode: this.state.documentUseCode,
      documentID: 0,
      processCallback: this.renderImages,
    });

    transporterInstance.SetImageFromInput(e.currentTarget);

  }

  renderImages() {
    if (transporterInstance) {
      if (isImage(transporterInstance.fileTypeCode)) {
        this.setState({memoryImg: transporterInstance.newImage.toDataURL()});
      } else {
        this.setState({memoryImg: false});
      }
    } else {
      this.setState({memoryImg: baseImg});
    }

    if (this.state.fileGUID) {
      let result;

      if (this.state.documentUseCode === TTDocumentUseEnum.DU_ATTACHMENT) {
        result =  BuildImageURLForFileGUID({
                    fileGUID: this.state.fileGUID,
                    defaultImage: "blank.gif",
                    objectTypeCode: this.state.objectTypeCode,
                    objectSubtypeCode: this.state.objectSubtypeCode,
                    forcePrivate: true,
                  });
      } else {
        result =  BuildImageURLForFileGUID({
                    fileGUID: this.state.fileGUID,
                    defaultImage: "blank.gif",
                    objectTypeCode: this.state.objectTypeCode,
                    objectSubtypeCode: this.state.objectSubtypeCode,
                    forcePrivate: false,
                  });
      }

      this.setState({
        savedImg: result,
        serverURL: result,
      });

    } else {
      this.setState({
        savedImg: baseImg,
        serverURL: '',
      });
    }
  }

  upload() {
    this.fileUploadInput.click();
  }

  validate() {
    let message = '';
    if (this.state.objectTypeCode < 1) {
      message = 'Please select an object type';
    } else if (!this.state.objectKeyGUID.length) {
      message = 'Please provide an object key GUID';
    } else if (!validator.isUUID(this.state.objectKeyGUID)) {
      message = 'Please provide a valid object key GUID';
    } else if (!Number.isInteger((Number(this.state.objectSubkeyID))) || Number(this.state.objectSubkeyID) < 0) {
      message = 'Please check sub-object key ID. It must be zero or a positive integer';
    } else if (!transporterInstance) {
      message = 'Please select a document';
    }

    if (message) {
      this.props.showMessageBox({
        title: 'Invalid Entry',
        message,
      });
      return false;
    }
    return true;
  }

  save() {
    if (this.validate()) {
      transporterInstance.callback          = this.saveCallback;
      transporterInstance.errorCallback     = hError;
      transporterInstance.objectTypeCode    = this.state.objectTypeCode;
      transporterInstance.objectKeyGUID     = this.state.objectKeyGUID;
      transporterInstance.objectSubtypeCode = this.state.objectSubtypeCode;
      transporterInstance.objectSubkeyID    = this.state.objectSubkeyID;
      transporterInstance.documentUseCode   = this.state.documentUseCode;

      if (this.state.objectSubtypeCode === TTObjectSubtypeEnum.OST_TASK_STEP_ID || this.state.documentUseCode === TTDocumentUseEnum.DU_ATTACHMENT) {
        transporterInstance.allowMultiple = true;
      } else {
        transporterInstance.allowMultiple = false; 
      }
      
      this.props.isLoading(true);
      transporterInstance.SaveImage();
    }
  }

  saveCallback(data) {
    this.setState({
      fileGUID: data.fileGUID,
    });
    setTimeout(this.renderImages, 0);
    this.props.isLoading(false);
  }

  render() {
    const memoryImgStyle = {
      backgroundImage: this.state.memoryImg ? `url(${this.state.memoryImg})` : `url(${fileIconImg})`,
    }

    const savedImgStyle = {
      backgroundImage: `url(${this.state.savedImg})`,
    }

    return (
      <div className='FileUploader'>
        <Masthead title='File Uploader' icon='fa fa-image' />
        <Page>
          <section className='section'>
            <div className='row'>
              <div className='col-xs-6'>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='FileUpload_ddObjectTypeCode'>Object Type</label>
                    <select onChange={this.onChange} name='objectTypeCode' value={this.state.objectTypeCode} className='form-control'>
                      <option value='0'>None</option>
                      <option value='1'>Task</option>
                      <option value='2'>Team</option>
                      <option value='3'>User</option>
                      <option value='4'>Community</option>
                      <option value='6'>Promotion</option>
                      <option value='7'>Enterprise</option>
                    </select>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='objectKeyGUID'>Object Key GUID</label>
                    <input  onChange={this.onChange} className='form-control' name='objectKeyGUID' value={this.state.objectKeyGUID} />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='FileUpload_ddObjectSubtypeCode'>Sub-Object Type</label>
                    <select onChange={this.onChange} name='objectSubtypeCode' value={this.state.objectSubtypeCode} className='form-control'>
                      <option value='0'>None</option>
                      <option value='1'>Document</option>
                      <option value='2'>Comment</option>
                      <option value='3'>Task Item</option>
                      <option value='4'>Task Step</option>
                      <option value='5'>Enterprise Vision</option>
                    </select>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='FileUpload_txtObjectSubkeyID'>Sub-Object Key ID</label>
                    <input onChange={this.onChange} className='form-control' name='objectSubkeyID' value={this.state.objectSubkeyID} />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='documentUseCode'>Document Use</label>
                    <select onChange={this.onChange} name='documentUseCode' value={this.state.documentUseCode} className='form-control'>
                      <option value='10'>General</option>
                      <option value='30'>Attachment</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-xs-6'>
                <div className='row'>
                  <div className='col-xs-10 form-group'>
                    <label className='text-primary' htmlFor='FileUpload_txtFileGUID'>File GUID</label>
                    <input className='form-control' name='FileUpload_txtFileGUID' value={this.state.fileGUID} />
                  </div>
                  <div className='col-xs-2'>
                    <div className='row'>
                      <div className='col-xs-12 form-group'>
                        <div className='form-info-wrapper light-label FileUploader__img-label'>
                          <strong>Memory</strong>
                        </div>
                        <div className='avatar-image'>
                          <div style={memoryImgStyle} className='img-mask'></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-10 form-group'>
                    <label className='text-primary' htmlFor='FileUpload_txtServerURL'>Server URL</label>
                    <textarea
                      style={{height: 150, overflow: 'auto'}}
                      className='fileUpload-text-area'
                      spellCheck={false}
                      rows='4'
                      value={this.state.serverURL}
                    />
                  </div>
                  <div className='col-xs-2'>
                    <div className='row'>
                      <div className='col-xs-12 form-group'>
                        <div className='form-info-wrapper light-label FileUploader__img-label'>
                          <strong>Saved</strong>
                        </div>
                        <div className='avatar-image'>
                          <div style={savedImgStyle} className='img-mask'></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row FileUploader__buttons'>
                  <div className='col-xs-12'>
                    <div className='row'>
                      <div className='col-xs-5 col-xs-offset-1'>
                        <button onClick={this.upload} className='btn btn-primary btn-block'>Upload File</button>
                      </div>
                      <div className='col-xs-5'>
                        <button onClick={this.save} className='btn btn-primary btn-block'>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input
              ref={(input => this.fileUploadInput = input)}
              type="file"
              className="hiddenInput add-hero"
              onChange={this.onFileChange}
            />
          </section>
        </Page>
      </div>
    );
  }
}

export default FileUploader;



// WEBPACK FOOTER //
// ./src/components/Utilities/FileUploader.js